const environment = {
    //  apiUrl: 'https://localhost:44325/api/',  // local
    // apiCarparkUrl: 'https://localhost:44325/api/',  // Carpark local

    // apiUrl: 'https://localhost/api/',  // Local Server
    // apiCarparkUrl: 'http://localhost:8086/api/',  // Local Server
    // apiReport: 'https://localhost:446/', // Local Server
    // apiPayment: 'https://localhost:449/', // Local Server
    // webPayment: 'https://tgg-payment.tgh.co.th/', // Local 

    apiUrl: 'https://fineday-api.objective-faraday.119-59-118-127.plesk.page/api/',  // prod Server
    apiCarparkUrl: 'https://fineday-api.objective-faraday.119-59-118-127.plesk.page/api/',  // prod Server
    apiReport: 'https://tgq-reports.tgh.co.th/', // prod Server
    apiPayment: 'https://tgq-apipayment.tgh.co.th/', // prod Server
    webPayment: 'https://tgq-payment.tgh.co.th/', // prod Server
    
    // apiUrl: 'https://tgq-api.tgh.co.th/api/',  // prod Server
    // apiCarparkUrl: 'https://tgq-apicarpark.tgh.co.th/api/',  // prod Server
    // apiReport: 'https://tgq-reports.tgh.co.th/', // prod Server
    // apiPayment: 'https://tgq-apipayment.tgh.co.th/', // prod Server
    // webPayment: 'https://tgq-payment.tgh.co.th/', // prod Server
}
export default environment